import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import STATUS from '@common/constants/reducer_statuses'
import API, { API_VERSION, REQUEST_METHOD } from '@app/api'


export const initialState = {
  notificationsRecent: {
    data: [],
    status: STATUS.IDLE,
    error: null,
  },
}

export const fetchRecentNotifications = createAsyncThunk('notifications/fetchRecentNotifications', async (_, { rejectWithValue }) => {
  try {
    const notificationsRecent = await API('notifications/', API_VERSION.TWO).request(REQUEST_METHOD.GET, {}, {})
    return notificationsRecent
  } catch (err) {
    return rejectWithValue(err.errors._error)
  }
})

export const markNotificationAsViewed = createAsyncThunk('notifications/markNotificationAsViewed', async (updatedIDs, { rejectWithValue }) => {
  try {
    await API('notifications/', API_VERSION.TWO).request(REQUEST_METHOD.PUT, undefined, { id: updatedIDs })
    return updatedIDs
  } catch (err) {
    return rejectWithValue(err.errors._error)
  }
})

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchRecentNotifications.pending]: state => {
      state.notificationsRecent.status = STATUS.LOADING
    },
    [fetchRecentNotifications.fulfilled]: (state, action) => {
      state.notificationsRecent.status = STATUS.SUCCEEDED
      state.notificationsRecent.data = action.payload || []
      state.notificationsRecent.error = null
    },
    [fetchRecentNotifications.rejected]: (state, action) => {
      state.notificationsRecent.status = STATUS.FAILED
      state.notificationsRecent.data = []
      state.notificationsRecent.error = action.error.message
    },
    [markNotificationAsViewed.pending]: state => {
    },
    [markNotificationAsViewed.fulfilled]: (state, action) => {
      const updatedIDs = action.payload || []
      state.notificationsRecent.data = state.notificationsRecent.data.map(n => {
        if (updatedIDs.includes(n.id)) {
          return {
            ...n,
            viewed: true,
          }
        }
        return n
      })
      state.notificationsRecent.error = null
    },
    [markNotificationAsViewed.rejected]: (state, action) => {
      state.notificationsRecent.error = action.error.message
    },
  },
})

export default notificationsSlice.reducer
